import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3, TS_MultiSelect_V2 } from '@nu-art/thunderstorm-frontend';
import { ModuleFE_AIPrompt } from './ModuleFE_AIPrompt.js';
import { DBItemDropDownMultiSelector } from '@nu-art/thunderstorm-frontend/components/_TS_MultiSelect/DBItemDropDownMultiSelector';
import { TS_Icons } from '@nu-art/ts-styles';
const Props_DropDown = {
    module: ModuleFE_AIPrompt,
    modules: [ModuleFE_AIPrompt],
    mapper: item => [item.label],
    placeholder: 'Choose a prompt',
    renderer: item => _jsx(_Fragment, { children: item.label })
};
export const DropDown_AIPrompt = GenericDropDownV3.prepare(Props_DropDown);
const Props_MultiSelect = DBItemDropDownMultiSelector.propsV3({
    module: ModuleFE_AIPrompt,
    itemRenderer: (item, onDelete, disabled) => {
        return _jsxs(_Fragment, { children: [!disabled && _jsx(TS_Icons.x.component, { onClick: onDelete }), !item ? _jsx(_Fragment, { children: "Not Found" }) : _jsx(_Fragment, { children: item.label })] });
    },
    uiSelector: DropDown_AIPrompt.selectable,
});
export const MultiSelect_AIPrompt = TS_MultiSelect_V2.prepare(Props_MultiSelect);
//# sourceMappingURL=ui-components.js.map